import React from "react";
import x from './x.png';
import discord from './discord.png';
import telegram from './telegram.png';

function Footer() {
  return (
    <div className="footer">
      <div className="container">
        <a href="https://t.me/+i5oTJld2iadhZWQ5" target="_blank" rel="noopener noreferrer">
          <img src={telegram} alt="Telegram" className="footer-image" />
        </a>
        <a href="https://x.com/icecream_gf" target="_blank" rel="noopener noreferrer">
          <img src={x} alt="Twitter" className="footer-image" />
        </a>
        <a href="https://discord.gg/V34mjMFe" target="_blank" rel="noopener noreferrer">
          <img src={discord} alt="Discord" className="footer-image" />
        </a>
        </div>
    </div>
  );
}

export default Footer;
